import InputNode from './InputNode';
import AgentNode from './AgentNode';
import TaskNode from './TaskNode';
import ConfigNode from './ConfigNode';
import { DashedEdge, LineEdge, CustomEdge } from './WorkflowEdges';

export const proOptions = {
  hideAttribution: true,
};

export const nodeTypes = {
  input: InputNode,
  agent: AgentNode,
  task: TaskNode,
  config: ConfigNode
};

export const edgeTypes = {
  custom: CustomEdge,
  dashed: DashedEdge,
  line: LineEdge
};
